import app from 'flarum/forum/app';

/**
 * settings.js —— 读后台可配置的站点文案。
 *
 * 数据来源: 服务端 Extend\Settings::serializeToForum() 把每个 setting 下发成
 * forum API 的 attribute ⇒ 前台 app.forum.attribute('geewen_xxx') 读得到。
 *
 * ⚠️ 兜底链 (很重要):
 *   后台填了值 ⇒ 用后台的值
 *   后台留空 ⇒ **回落到 locale 文案** (中英双语都在 locale 里)
 * ⇒ 所以「清空某个输入框」= 恢复成官网的默认文案, 而不是空白。
 *
 * ⚠️ setting 值是**单一字符串**, 不分语言 —— 后台填什么就是什么。
 *    想要英文版就填英文, 或留空让 locale 兜底。
 */

/**
 * 取一条可配置文案。
 *
 * @param {string} key setting key, 如 'geewen_hero_title'
 * @param {string} fallback 后台留空时的兜底 (通常来自 locale)
 * @returns {string}
 */
export function gs(key, fallback) {
  const value = app.forum.attribute(key);
  return value === undefined || value === null || value === '' ? fallback : value;
}

/**
 * 取一个布尔型设置 (产品是否展示)。
 *
 * Flarum 的 bool setting 存的是 '1' / '0' 字符串。
 *
 * @param {string} key
 * @param {boolean} fallback
 * @returns {boolean}
 */
export function gsBool(key, fallback) {
  if (fallback === void 0) {
    fallback = true;
  }
  const value = app.forum.attribute(key);
  if (value === undefined || value === null || value === '') return fallback;
  return value !== '0' && value !== 'false';
}

/**
 * 取一个产品的前缀 (scheduler ⇒ 'geewen_product_scheduler')。
 *
 * ⚠️ slug 必须和 products.js 的 PRODUCTS 注册表一致。
 *
 * @param {string} slug
 * @returns {string}
 */
export function productPrefix(slug) {
  return 'geewen_product_' + slug.replace(/-/g, '');
}
flarum.reg.add('ziiven-geewen-site', 'forum/helpers/settings', { gs: gs,gsBool: gsBool,productPrefix: productPrefix, });